const STROKE = "#1b1a17";

/** House: green gabled body with a door. Own drawing, 24 x 24 units. */
export function HouseIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Haus" focusable="false">
      <path d="M3.5 12 12 4l8.5 8" fill="none" stroke={STROKE} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.5 11.5 12 5.8l6.5 5.7V20h-13Z" fill="#2fa35d" stroke={STROKE} strokeWidth="1.8" strokeLinejoin="round" />
      <rect x="10" y="14" width="4" height="6" rx="0.6" fill="#f8f4e8" stroke={STROKE} strokeWidth="1.2" />
    </svg>
  );
}

/** Hotel: taller red block with two rows of windows and a flat roof. Own drawing, 24 x 24 units. */
export function HotelIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Hotel" focusable="false">
      <path d="M4 20V6.5L12 3l8 3.5V20Z" fill="#d6423a" stroke={STROKE} strokeWidth="1.8" strokeLinejoin="round" />
      <g fill="#f8f4e8" stroke={STROKE} strokeWidth="1">
        <rect x="6.8" y="8" width="3" height="3" rx="0.4" />
        <rect x="14.2" y="8" width="3" height="3" rx="0.4" />
        <rect x="6.8" y="13" width="3" height="3" rx="0.4" />
        <rect x="14.2" y="13" width="3" height="3" rx="0.4" />
      </g>
      <rect x="10.2" y="15" width="3.6" height="5" rx="0.5" fill="#f8f4e8" stroke={STROKE} strokeWidth="1.2" />
    </svg>
  );
}
